'use client';
import { __rest } from 'tslib';
import React from 'react';
import { Text } from './Text.js';
import { merge } from 'lodash';

const DEFAULT_TAG = 'h1';
const Heading = React.forwardRef((props, forwardedRef) => {
    // '2' here is the default heading size variant
    const { size = '1' } = props, textProps = __rest(props, ["size"]);
    // This is the mapping of Heading Variants to Text variants
    const textSize = {
        1: { '@initial': '4', '@bp2': '5' },
        2: { '@initial': '6', '@bp2': '7' },
        3: { '@initial': '7', '@bp2': '8' },
        4: { '@initial': '8', '@bp2': '9' },
    };
    // This is the mapping of Heading Variants to Text css
    const textCss = {
        1: { fontWeight: 500, lineHeight: '20px', '@bp2': { lineHeight: '23px' } },
        2: { fontWeight: 500, lineHeight: '25px', '@bp2': { lineHeight: '30px' } },
        3: { fontWeight: 500, lineHeight: '33px', '@bp2': { lineHeight: '41px' } },
        4: { fontWeight: 500, lineHeight: '35px', '@bp2': { lineHeight: '55px' } },
    };
    return (React.createElement(Text, Object.assign({ as: DEFAULT_TAG }, textProps, { ref: forwardedRef, size: textSize[size], css: Object.assign({ fontVariantNumeric: 'proportional-nums' }, merge(textCss[size], props.css)) })));
});

export { Heading };
